
import Save2 from "../../../assets/outline/Save2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Save2Icon({ className, dataTestid = "Save2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Save2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
